import { connect } from 'react-redux'
import {
  fetchLogoPreviews,
  updateSelectedLogoPreviews,
  updateLogoCanvas,
  getNextLogoPreview,
  getPreviousLogoPreview,
  stepLogoDownload,
  requestIcons
} from '../actions/new-logo'
import LogoPreview from '../components/LogoPreview'

const mapStateToProps = (state) => {
  return {
    newLogo: state.newLogo
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetMe: () => {
    },
    fetchLogoPreviews: (data) => {
      dispatch(fetchLogoPreviews(data))
    },
    requestIcons: (data) => {
      return dispatch(requestIcons(data))
      .then(icons => {
        return Promise.resolve(icons)
      })
      .catch(error => {
        return Promise.reject(error)
      })
    },
    updateSelectedLogoPreviews: (data) => {
      dispatch(updateSelectedLogoPreviews(data))
    },
    updateLogoCanvas: (data) => {
      dispatch(updateLogoCanvas(data))
      // Every time we draw a logo we also select it
      dispatch(updateSelectedLogoPreviews({
          selectedLogoPreviews: data.id,
          selectedLogoCanvas: data.canvas,
          selectedLogoImage: data.canvas.toDataURL('image/png'),
          selectedLogoImageDark: data.canvasDark.toDataURL('image/png')
      }))
    },
    getNextLogoPreview: () => {
      dispatch(getNextLogoPreview())
    },
    getPreviousLogoPreview: () => {
      dispatch(getPreviousLogoPreview())
    },
    stepLogoDownload: () => {
      dispatch(stepLogoDownload())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoPreview)



// WEBPACK FOOTER //
// ./src/containers/LogoPreview.js